import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/components/login/login.component';
import { NopagefoundComponent } from './shared/layout/nopagefound/nopagefound.component';
import { PagesComponent } from './pages/pages.component';
import { DashboardComponent } from './pages/components/dashboard/dashboard.component';
import { AuthGuard } from './models/auth/_services/auth.guard';


const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'pages', component: PagesComponent },
  { path: 'remember', component: LoginComponent },
  { path: 'Portal', redirectTo: '/login' },
  {
		path: '',
		canActivate: [AuthGuard],
		loadChildren: () =>
			import('../app/shared/layout/layout.module').then((m) => m.LayoutModule),
	},
  { path: '**', component: NopagefoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
